import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";

export const useDeleteSelectedCareer = (onSuccess) => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: `/users/me/selected-careers`,
    method: HttpMethod.Delete,
  });

  return useMutation({
    mutationKey: ["delete-selected-career"],
    mutationFn: (data) => mutationFn({ data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["selected-careers"] });

      // The deleted career may be for the current budget plan
      queryClient.invalidateQueries({ queryKey: ["budget-plan"] });

      onSuccess?.();
    },
  });
};
